import { effect, ElementRef, inject, signal, Signal } from '@angular/core';
import { FormModes } from './constants.lib';
import { ToastrService } from 'ngx-toastr';
import {
  CasiStoryStatus,
  EvaluationDomainType,
  EvaluationRatingScaleType,
  EvaluationType,
  OrganisationType, PlacementReviewStudentType,
  Role
} from '../models/models.lib';
// import { RuleEval } from "@casi-ts/utils";
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';

export const setTitle = (formMode: FormModes, title: string): string => {
  return `${formMode === FormModes.VIEW ? 'VIEW'
    : formMode === FormModes.NEW ? 'ADD'
      : formMode === FormModes.EDIT ? 'EDIT'
        : formMode === FormModes.COPY ? 'COPY'
          : ''} ${title}`;
};

export const findNearestNumber = (arr: number[], target: number): number => {
  // console.log('findNearestNumber: ', target, arr);
  let nearest = arr[0];
  let smallestDifference = Math.abs(target - nearest);
  arr.forEach(a => {
    const difference = Math.abs(target - a);
    if (difference < smallestDifference) {
      nearest = a;
      smallestDifference = difference;
    }
  })
  return nearest;
};

// export function isNotNull(val = null) {
//   return !!val || !(val === null);
// };


export function isNotNull(val: any = null) {
  return !!val || !(val === null);
};

export function casiNotify(msg: string = 'Not set', error: boolean = false): void {
  let toastr = inject(ToastrService);
  if (error) {
    toastr.error(msg, 'Error');
  } else {
    toastr.success(msg, 'Sucess');
  }
};

export const sureThing = (promise: Promise<any>): Promise<any> =>
  promise
    .then((data) => ({
      ok: true,
      data
    }))
    .catch((error) => Promise.resolve({
      ok: false,
      error
    }));

/**
 * Strip HTML tags from a html string.
 *
 * @param html
 * @returns
 */
export function stripHtmlTags(html: string = ''): string {
  const htmlRegX = /<(?:"[^"]*"['"]*|'[^']*'['"]*|[^'">])+>/g;
  return html.replace(htmlRegX, '');
};

// export function Poller() {
//   let pollHandle: any | undefined;
//   const settings = inject(SettingsService);
//   const pollingPeriod = settings.getSettings().pollingPeriod;
//   console.log('Poller:pollingPeriod: ', pollingPeriod);

//   function startPolling(pollFn: () => void): void {
//     if (!isNotNull(pollHandle))
//       pollHandle = setInterval(pollFn, pollingPeriod || 60000);
//   }
//   function stopPolling(): void {
//     clearInterval(pollHandle);
//     pollHandle = undefined;
//   }

//   return {
//     startPolling,
//     stopPolling
//   };

// }


export type fieldNames = string | string[];

export function setFocus(formName: ElementRef, name: fieldNames) {
  console.log('setFocus: type: ', typeof name);
  console.log('setFocus; name: ', name);
  if (typeof name === 'string') {
    const ele = formName.nativeElement[name]; // this.aForm.nativeElement[name];
    if (ele) {
      ele.focus();
    }
  } else {
    console.log('setFocus: isArray?', Array.isArray(name));
    if (Array.isArray(name)) {
      name.forEach(n => {
        console.log('setFocus: n', n);
        // let el = this.aForm.nativeElement[n];
        let el = formName.nativeElement[n];
        if (el) {
          el.focus();
        }
      })
    }
  }
};


/**
 * Take a number and pad it with zero for the
 * size given.  If not size, will default to 2
 *
 * @param {number} num
 * @param {number} size
 * @returns {string} Zero padded number as string
 */
export function zeroPadNumber(num: number, size: number = 2): string {
  var s = num.toString();
  while (s.length < size) s = "0" + s;
  return s;
}


export function _goTo(location: string) {
  window.location.hash = '';
  //window.location.hash = location;
  let foo = location.split('#');
  let baz = foo[foo.length - 1];
  setTimeout(() => {
    // $('html,body').animate({
    //   scrollTop: $("#" + baz).offset().top
    // }, 'slow');
  });

}

export function formatText(text?: string): string {
  if (!text) {
    return '';
  }
  if (text.match(/\<(.)\>/)) //if html do nothing
    return text;
  else {
    let tmp = text.split('\n');
    let result = '';
    tmp.forEach((line) => {
      let newStr = line.replace(/\*\*(.*?)\*\*/g, (match: string) => {
        let r = `<b>${match.replace(/\*\*/, '').replace(/\*\*/, '')}</b>`;
        return r;
      });
      result += `<p>${newStr}</p>`
    });
    return result;
  }
}

export function formatTextLink(text?: string, id?: string): string {
  if (!text) {
    return '';
  }
  if (text.match(/\<(.)\>/)) //if html do nothing
    return text;
  else {
    let tmp = text.split('\n');
    let result = '';
    tmp.forEach((line) => {
      let newStr = line.replace(/\*\*(.*?)\*\*/g, (match: string) => {
        let r = `<b>${match.replace(/\*\*/, '').replace(/\*\*/, '')}</b>`;
        return r;
      });
      result += `<p>${newStr}</p>`
    });
    if (result != '')
      return `<a href="/userstory/show/${id}" target="_blank">${result}</a>`;
    else
      return result;
  }
}

export function sortStatus(a: CasiStoryStatus, b: CasiStoryStatus): number {
  let aLower = a.user_story_status_description.toLowerCase();
  let bLower = b.user_story_status_description.toLowerCase();
  // this.logger.debug(`sortStatus: `, {
  //   aLower, bLower
  // });
  if (aLower < bLower)
    return -1;
  if (aLower > bLower)
    return 1;
  return 0;
}

// export const ruleEngine = new RuleEval();

export function debounceSignal<T>(source: Signal<T>, delay: number): Signal<T> {
  let timeout: any;
  let debouceQuery = signal(source());
  effect(() => {
    let value = source();
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      debouceQuery.set(value);
    }, delay);
  });
  return debouceQuery.asReadonly();
}




export function duplicateOrganisationValidator(
  organisations: OrganisationType[],
  mode: FormModes
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!organisations?.length) {
      return null;
    }

    const value = control.value;
    if (!value) {
      return null;
    }

    const duplicate = organisations.find((o) =>
      o.organisation_name === value.organisation_name &&
      o.business_owner_name === value.business_owner_name &&
      o.contact_email === value.contact_email &&
      o.contact_telephone === value.contact_telephone &&
      (mode === FormModes.NEW || o.id !== value.id)
    );

    return duplicate ? { duplicateOrganisation: true } : null;
  };
}


export function duplicateRoleValidator(
  roles: Role[],
  mode: FormModes
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!roles?.length) {
      return null;
    }

    const value = control.value;
    if (!value) {
      return null;
    }

    const duplicate = roles.find((o) =>
      o.name === value.name &&
      (mode === FormModes.NEW || o.id !== value.id)
    );

    return duplicate ? { duplicateRole: true } : null;
  };
}

export const passwordMatchValidator: ValidatorFn = (
  control: AbstractControl
): ValidationErrors | null => {

  const password = control.get('password')?.value;
  const confirmPassword = control.get('confirmPassword')?.value;

  if (!password || !confirmPassword) {
    return null;
  }

  return password === confirmPassword
    ? null
    : { passwordMismatch: true };
};


export function duplicateEvaluationValidator(
  list: EvaluationType[],
  mode: FormModes
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!list?.length) {
      return null;
    }

    const value = control.value;
    if (!value) {
      return null;
    }

    const duplicate = list.find((o) =>
      o.evaluation_name === value.evaluation_name &&
      (mode === FormModes.NEW || o.id !== value.id)
    );

    return duplicate ? { duplicateEvaluation: true } : null;
  };
}

export function duplicateEvaluationRatingScaleValidator(
  list: EvaluationRatingScaleType[],
  mode: FormModes
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!list?.length) {
      return null;
    }

    const value = control.value;
    if (!value) {
      return null;
    }

    const duplicate = list.find((o) =>
      o.rating_scale_value === value.rating_scale_value &&
      (mode === FormModes.NEW || o.id !== value.id)
    );

    return duplicate ? { duplicateEvaluationRatingScale: true } : null;
  };
}

export function duplicateEvaluationDomainValidator(
  list: EvaluationDomainType[],
  mode: FormModes
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!list?.length) {
      return null;
    }

    const value = control.value;
    if (!value) {
      return null;
    }

    const duplicate = list.find((o) =>
      o.domain_description === value.domain_description &&
      (mode === FormModes.NEW || o.id !== value.id)
    );

    return duplicate ? { duplicateEvaluationDomain: true } : null;
  };
}

export function truncateHtml(
  html: string,
  sanitizer: DomSanitizer,
  limit: number = 50
): SafeHtml {
  if (!html) return '';

  const text = html.replace(/<[^>]+>/g, '');
  const truncated = text.length > limit ? text.substr(0, limit) + '…' : text;

  return sanitizer.bypassSecurityTrustHtml(truncated);
}

// export function duplicateReviewStudentValidator(
//   list: PlacementReviewStudentType[],
//   mode: FormModes
// ): ValidatorFn {
//   return (control: AbstractControl): ValidationErrors | null => {
//     if (!list?.length) {
//       return null;
//     }

//     const value = control.value;
//     if (!value) {
//       return null;
//     }

//     const duplicate = list.find((o) =>
//       o.student_email === value.student_email && o.placement_review_id === value.placement_review_id &&
//       (mode === FormModes.NEW || o.id !== value.id)
//     );

//     return duplicate ? { duplicateReviewStudent: true } : null;
//   };
// }

export function decimalPattern(decimalPlaces: number): RegExp {

  if (!decimalPlaces || decimalPlaces <= 0) {
    return /^\d+$/;
  }

  return new RegExp(
    `^\\d+(\\.\\d{1,${decimalPlaces}})?$`
  );
}

export function deboucedSignal<T>(input: Signal<T>, timeOutMs = 0): Signal<T> {
  const debounceSignal = signal(input());
  effect(() => {
    const value = input();
    const timeout = setTimeout(() => {
      debounceSignal.set(value);
    }, timeOutMs);
    return () => {
      clearTimeout(timeout);
    }
  });
  return debounceSignal;
}
